<ng-template #modalPreviewPortal>
    <div class="modal-preview">
        <web-payment-form-modal-preview [widget]="widgetSnapshot()" />
    </div>
</ng-template>

<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="onReset()">
            <img src="./assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        <span>{{ "control_modal_form_styles" | translate }}</span>
    </div>
</web-settings-breadcrumbs>

<sp-form-input-settings-signal isPaymentForm [settings]="settings()" (valueChangeEvent)="onSettingsChange($event)" />

<web-settings-footer (saveEvent)="onSave()" (cancelEvent)="onReset()" />
